import { TaggedEntity } from '../types';
import { SpoilerTag } from '../constants/constants';
import { ATCC_TAG } from './atcc-merge';

const CYCLE_TAG_ORDER = [SpoilerTag.CYCLE_I, SpoilerTag.CYCLE_II, SpoilerTag.CYCLE_III, SpoilerTag.CYCLE_IV, SpoilerTag.CYCLE_V];

export function getVisibilityTags(tags: string[] = []): string[] {
    return tags.filter((tag) => tag && tag.trim() !== '' && tag !== ATCC_TAG);
}

export function expandCycleSpoilerTags(tags: string[] = []): string[] {
    const visibilityTags = getVisibilityTags(tags);
    const highestCycleIndex = CYCLE_TAG_ORDER.reduce((highestIndex, cycleTag, index) => (visibilityTags.includes(cycleTag) ? index : highestIndex), -1);
    const expandedCycleTags = highestCycleIndex >= 0 ? CYCLE_TAG_ORDER.slice(0, highestCycleIndex + 1) : [];
    const nonCycleTags = visibilityTags.filter((tag) => !CYCLE_TAG_ORDER.includes(tag as SpoilerTag));

    return Array.from(new Set([...expandedCycleTags, ...nonCycleTags])).sort((a, b) => a.localeCompare(b));
}

export function summarizeSpoilerTagsForDisplay(tags: string[] = []): string[] {
    const uniqueTags = Array.from(new Set(getVisibilityTags(tags)));
    const highestCycle = [...CYCLE_TAG_ORDER].reverse().find((cycleTag) => uniqueTags.includes(cycleTag)) ?? SpoilerTag.CYCLE_I;
    const nonCycleTags = uniqueTags.filter((tag) => !CYCLE_TAG_ORDER.includes(tag as SpoilerTag)).sort((a, b) => a.localeCompare(b));

    return [highestCycle, ...nonCycleTags];
}

export function shouldShowTaggedEntity(entity: TaggedEntity, visibleTags: string[] = []): boolean {
    const visibilityTags = getVisibilityTags(entity.tags ?? []);
    return visibilityTags.length === 0 || visibilityTags.some((tag) => visibleTags.includes(tag));
}

export function getUniqueTags(taggedEntities: TaggedEntity[]): string[] {
    const itemTags = taggedEntities.flatMap((item) => getVisibilityTags(item.tags ?? []));
    const uniqueTags = Array.from(new Set(itemTags)).sort();
    return uniqueTags;
}
